<template>
  <div class="water-container">
    <waterfall :col="col" :data="list" :gutterWidth="15">
      <template v-for="(item, index) in list">
        <top-article :key="'1' + index" v-if="item.is_top" :item="item" />
        <common-article :key="'2' + index" :item="item" v-else />
      </template>
    </waterfall>
  </div>
</template>
<script>
import waterfall from "@/components/waterfall";
import TopArticle from "./topArticle";
import CommonArticle from "./commonArticle";

export default {
  name: "articleItem",
  props: {
    list: {
      type: Array,
      default: () => []
    },
    keyword: {
      type: String,
      default: ""
    }
  },
  components: {
    waterfall,
    TopArticle,
    CommonArticle
  },
  data() {
    return {
      col: 3
    };
  }
};
</script>
<style lang="less" scoped>
#vueWaterfall {
  /deep/.vue-waterfall-column {
    width: calc(33.33% - 10px) !important;
  }
  & > .vue-waterfall-column:nth-child(3) .article-list-item {
    margin-left: 0;
  }
}
.water-container {
  width: 100%;
}
</style>
